import React from 'react';
import ChangePolicy from '../assets/images/icon-change-policy.svg';

export default () => {
  return <img src={ChangePolicy} alt="Change policy" />;
};
